import dynamic from 'next/dynamic';
import Script from 'next/script';
const InnerHTML = dynamic(() => import('dangerously-set-html-content'), {ssr: false})


const AnalyticsScriptInjector = ({ data, template_settings}) => {

    const google_conversion = template_settings?.google_conversion == 'yes';
    const google_conversion_id = template_settings?.google_conversion_id ?? '';
    const google_conversion_label = template_settings?.google_conversion_label ?? '';

    return (
        <>
            <InnerHTML html={data} />

            {google_conversion && (
                <>
                    <Script 
                        strategy="afterInteractive"
                        src="//www.googleadservices.com/pagead/conversion_async.js"
                    />

                    <Script id="google-conversion-inline" strategy="afterInteractive">
                        {`
                            goog_snippet_vars = function() {
                            var w = window;
                            w.google_conversion_id = ${Number(google_conversion_id)};
                            w.google_conversion_label = "${google_conversion_label}";
                            w.google_remarketing_only = false;
                            };

                            goog_report_conversion = function(url) {
                            goog_snippet_vars();
                            window.google_conversion_format = "3";
                            var opt = new Object();
                            opt.onload_callback = function() {
                                if (typeof(url) != 'undefined') {
                                window.location = url;
                                }
                            };
                            var conv_handler = window['google_trackConversion'];
                            if (typeof(conv_handler) == 'function') {
                                conv_handler(opt);
                            }
                            };
                        `}
                    </Script>
                </>
            )}
        </>
    );
  };
  
  export default AnalyticsScriptInjector;
  